<template>
  <v-bottom-sheet v-model="active" :persistent="persist">
    <v-sheet class="text-center">
      <h3 class="py-2">
        <v-icon class="pb-1">mdi-delete-empty</v-icon> {{ title }}
      </h3>
      <div class="py-3 text-body-1" v-html="content"></div>
      <v-btn
        v-for="btn of buttons"
        :key="btn.text"
        class="my-5 mx-1"
        :outlined="btn.outlined"
        :color="btn.color"
        @click="btn.action"
      >
        <v-icon small v-if="btn.icon">mdi-{{ btn.icon }}</v-icon>
        {{ btn.text }}
      </v-btn>
    </v-sheet>
  </v-bottom-sheet>
</template>

<script lang="ts">
import Vue from "vue";
import VueTypes from "vue-types";

export default Vue.extend({
  name: "DeletePop",

  data() {
    return {
      selected: [],
    };
  },
  props: {
    persist: VueTypes.bool.def(false),
  },
  computed: {
    modal(): any {
      return this.$store.getters.getDeleteDialog;
    },
    active: {
      get(): boolean {
        return this.modal.active;
      },
      set(val: boolean) {
        this.$store.commit("setDeleteDialogActive", val);
      },
    },
    content(): string {
      return this.modal.content;
    },
    title(): string {
      return this.modal.title;
    },
    action(): any {
      return this.modal.action;
    },
    buttons(): any[] {
      return [
        {
          text: "Cancel",
          color: "primary",
          outlined: true,
          action: this.close,
          icon: "cancel",
        },
        {
          text: "Delete",
          color: "error",
          icon: "delete-empty",
          action: this.runAction,
        },
      ];
    },
  },
  methods: {
    runAction() {
      this.action();
      this.close();
    },
    close() {
      this.active = false;
    },
  },
});
</script>
